import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import { API, useAuth } from "../context/AuthContext";
import { Gift } from "lucide-react";

const abs = (u) => (u && u.startsWith("/api/") ? `${API.replace(/\/api$/, "")}${u}` : u);

export default function ReferralLanding() {
  const { code } = useParams();
  const { user } = useAuth();
  const [inv, setInv] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { localStorage.setItem("rl_ref", code.toUpperCase()); axios.get(`${API}/ref/${code}`).then(r => setInv(r.data)).catch(() => setErr(true)); }, [code]);
  return (
    <div className="min-h-screen grain-bg"><Navbar />
      <section className="pt-28 pb-24 max-w-2xl mx-auto px-5 text-center">
        {err && <div className="rl-card p-10" data-testid="referral-invalid"><h1 className="font-display font-black text-3xl mb-2">Codice invito non valido</h1><Link to="/register" className="btn-crimson mt-4 inline-block">CREA IL TUO PROFILO</Link></div>}
        {inv && <div className="rl-banner rl-watermark p-8 md:p-12" data-testid="referral-landing">
          <div className="relative">
            <div className="w-20 h-20 mx-auto rounded-full bg-[#FF1E27] overflow-hidden flex items-center justify-center font-display font-black text-3xl mb-4">{inv.avatar_url ? <img src={abs(inv.avatar_url)} alt="" className="w-full h-full object-cover" /> : inv.nickname[0]}</div>
            <div className="pill-badge pill-amber inline-flex mb-3"><Gift className="w-3 h-3" /> INVITO PERSONALE · {inv.code}</div>
            <h1 className="headline-huge text-3xl md:text-5xl mb-3" data-testid="referral-title">{inv.nickname.toUpperCase()} TI INVITA IN RALLY LOVE</h1>
            <p className="text-slate-300 mb-6">Entra nell'Official Paddock, pronostica con FANTARALLY, gioca ai quiz e sfida {inv.nickname} nel Campionato Fan. Solo punti virtuali, nessuna scommessa.</p>
            {user ? <Link to="/community" className="btn-crimson min-h-[48px] inline-flex items-center" data-testid="referral-go-community">SEI GIÀ DENTRO · VAI ALLA COMMUNITY</Link>
                  : <div className="flex flex-wrap gap-3 justify-center"><Link to="/register?next=/community" className="btn-crimson min-h-[48px] inline-flex items-center" data-testid="referral-register-btn">CREA IL TUO PROFILO</Link><Link to="/paddock" className="btn-outline-rl min-h-[48px] inline-flex items-center">GUARDA I RALLY</Link></div>}
            <p className="text-[11px] text-slate-500 mt-6">Chi ti ha invitato riceve punti XP virtuali solo quando completi la registrazione e la prima attività. Nessun guadagno in denaro.</p>
          </div>
        </div>}
      </section>
    </div>
  );
}
